/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S3_Li2Inputs */

const tr_kvkkbasvuru_s3_li2 = /** @type {(inputs: Kvkkbasvuru_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T.C. kimlik numarası (yabancılar için uyruk, pasaport numarası)`)
};

const en_kvkkbasvuru_s3_li2 = /** @type {(inputs: Kvkkbasvuru_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T.C. identity number (for foreign nationals, nationality and passport number)`)
};

const de_kvkkbasvuru_s3_li2 = /** @type {(inputs: Kvkkbasvuru_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T.C. Personalausweisnummer (für Ausländer Staatsangehörigkeit und Passnummer)`)
};

const ru_kvkkbasvuru_s3_li2 = /** @type {(inputs: Kvkkbasvuru_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Номер удостоверения личности T.C. (для иностранцев гражданство и номер паспорта)`)
};

/**
* | output |
* | --- |
* | "T.C. identity number (for foreign nationals, nationality and passport number)" |
*
* @param {Kvkkbasvuru_S3_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s3_li2 = /** @type {((inputs?: Kvkkbasvuru_S3_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S3_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s3_li2(inputs)
	if (locale === "de") return de_kvkkbasvuru_s3_li2(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s3_li2(inputs)
	return tr_kvkkbasvuru_s3_li2(inputs)
});